import React, { useEffect} from "react";
import { useImmer } from "use-immer";
import { errorMessage, successMessage } from "../../../utils";
import { createReportCategoryApi, createReportClassApi, getReportSettingsListApi } from "../api";

export const useReportsSettings = () => {
    const [state, setState] = useImmer({
        isLoading: true,
        classesDataList: [],
        categoriesDataList: [],
        categoriesDataFilteredList: [],
        isOpenClassName: false,
        isOpenCategory: false,
        className: "",
        classId: null,
        categoryName: "",
        filterClassId: null
    });

    useEffect(() => {
        getReportSettingsList()
    }, [])

    const getReportSettingsList = async () => {
        setState((draft) => {
            draft.isLoading = true;
        });
        try {
            const res = await getReportSettingsListApi();
            console.log(res);

            setState((draft) => {
                draft.classesDataList = res.data.classes;
                draft.categoriesDataList = res.data.categories;
                draft.categoriesDataFilteredList = res.data.categories;
                draft.isLoading = false;
            });
        } catch (error) {
            errorMessage(error);
            setState((draft) => {
                draft.isLoading = false;
            });
        }
    };

    const handleModal = (type, open) => {
        switch (type) {
            case "className":
                setState((draft) => {
                    draft.isOpenClassName = open;
                    draft.className = "";
                });
                break;
            case "category":
                setState((draft) => {
                    draft.isOpenCategory = open;
                    draft.categoryName = "";
                    draft.classId = null;
                });
                break;
            default:
                break;
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState((draft) => {
            draft[name] = value;
        });
    };

    const onSubmitClassName = async () => {

        try {
            let payload = {
                name: state.className
            }
            const res = await createReportClassApi(payload);
            if (res.success) {
                successMessage(res.message);
                getReportSettingsList();
            } else {
                errorMessage(res.message);
            }
            setState((draft) => {
                draft.isOpenClassName = false;
                draft.className = "";
            });


        } catch (error) {
            errorMessage(error);
        }

    }

    const onSubmitCategory = async () => {
        try {
            let payload = {
                name: state.categoryName,
                class_id: state.classId
            }
            const res = await createReportCategoryApi(payload);
            if (res.success) {
                successMessage(res.message);
                getReportSettingsList();
            } else {
                errorMessage(res.message);
            }
            setState((draft) => {
                draft.isOpenCategory = false;
                draft.categoryName = "";
                draft.classId = null;
            });

        } catch (error) {
            errorMessage(error);
        }

    }

    const handleFilterList = (classID) => {
        console.log(classID, state.categoriesDataList, state.categoriesDataList.filter(
            (category) => category.class.id === classID
        ));

        setState((draft) => {
            if (!classID) {
                draft.categoriesDataFilteredList = draft.categoriesDataList;
            } else {
                draft.categoriesDataFilteredList = draft.categoriesDataList.filter(
                    (category) => category.class.id === classID
                );
            }
            draft.filterClassId = classID;
        });
    };

    return {
        state,
        handleModal,
        handleInputChange,
        onSubmitClassName,
        onSubmitCategory,
        handleFilterList,
    };
};
